/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "./Base"

const Restore = (props) => (
  <BaseSvgIcon {...props} viewBox="0 0 25 16">
    <g id="UX-Specification-document" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round">
      <g
        id="Insights-homepage,-Archived-surveys-tab---Desktop"
        transform="translate(-951.000000, -291.000000)"
        stroke="#3D3D35"
        strokeWidth="1.3">
        <g id="Group-10" transform="translate(145.000000, 251.000000)">
          <g id="Group-25" transform="translate(797.000000, 30.000000)">
            <g id="Restore-Survey-copy-3" transform="translate(10.000000, 10.000000)">
              <path
                d="M1.13,8.6 C1.63832727,6.19028298 3.76452169,4.46563236 6.2272707,4.46537761 C8.69001971,4.46512285 10.8165709,6.18933356 11.3253967,8.59894536 C11.8342225,11.0085572 10.5863263,13.4453332 8.3337301,14.4407946 C6.08113394,15.4362559 3.43918251,14.718471 2,12.72"
                id="Path"
              />
              <polyline id="Path" strokeLinejoin="round" points="0.24 6.64 1.08 8.72 3.13 7.89" />
              <polyline id="Path" strokeLinejoin="round" points="3.14 3.17 3.14 0.97 22.87 0.97 22.87 11.88 13.2 11.88" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </BaseSvgIcon>
)

export default Restore
